import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
import { apiScopes as defaultScopes } from './msalConfig';

let msalInstance: PublicClientApplication | null = null;
let runtimeScopes: string[] = defaultScopes;

export function setMsalInstance(instance: PublicClientApplication) {
  msalInstance = instance;
}

export function setApiScopes(scopes: string[]) {
  runtimeScopes = scopes;
}

export async function getAccessToken(): Promise<string> {
  if (!msalInstance) throw new Error('MSAL not initialized');

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) throw new Error('No authenticated account');

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: runtimeScopes,
      account: accounts[0],
    });
    return response.accessToken;
  } catch (err) {
    if (err instanceof InteractionRequiredAuthError) {
      const response = await msalInstance.acquireTokenPopup({ scopes: runtimeScopes });
      return response.accessToken;
    }
    throw err;
  }
}
